'use es6';

import { createSelector } from 'reselect';
import * as AssetBusinessType from 'ecosystem-marketplace-core/constants/groupTags/AssetBusinessType';
import * as AssetPageType from 'ecosystem-marketplace-core/constants/groupTags/AssetPageType';
import * as AssetPageFeature from 'ecosystem-marketplace-core/constants/groupTags/AssetPageFeature';
import { isFulfilled, isSucceeded } from 'ecosystem-marketplace-core/utils/requestState';
import { getUnusedFiltersData, getUnusedFiltersRequestState } from './storefront';

const createUsedFiltersSelector = (unusuedFiltersKey, valuesSelector) => createSelector([valuesSelector, getUnusedFiltersData, getUnusedFiltersRequestState], (values, unusedFiltersData, unusedFiltersRequestState) => {
  if (!isFulfilled(unusedFiltersRequestState)) {
    return [];
  }

  if (!isSucceeded(unusedFiltersRequestState)) {
    return values;
  }

  const unusedvalues = unusedFiltersData.get(unusuedFiltersKey);
  return values.filter(value => !unusedvalues.includes(value));
});

export const getBusinessTypes = () => Object.values(AssetBusinessType);
export const getUsedBusinessTypes = createUsedFiltersSelector('unusedIndustries', getBusinessTypes);
export const getUsedPageTypes = createUsedFiltersSelector('unusedPageTypes', () => Object.values(AssetPageType));
export const getUsedPageFeatures = createUsedFiltersSelector('unusedPageFeatures', () => Object.values(AssetPageFeature));